// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Cl-z","tupacHeader":"Dl-z","tupacHeader2":"El-z","tupacMenu":"Fl-z","tupacMenu2":"Gl-z","tupacMain":"Hl-z","tupacMain2":"Il-z"};